import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { EventService } from '../../core/services/event.service';
import { ActivatedRoute } from '@angular/router';
import { LearningResourceService } from '../../core/services/learning-resource.service';

@Component({
  selector: 'app-single-album',
  templateUrl: './single-resource.component.html',
  styleUrls: ['./single-resource.component.scss'],
})
export class SingleResourceComponent implements OnInit {
  breadcrumbs: any[] = [];
  article = {
    name: '',
    description: '',
    description1: [],
    createdAt: '',
    link: '',
    thumbnail: { mimeType: 'test', url: 'test', filename: 'test' },
    media: { mimeType: 'test', url: 'test', filename: 'test' },
    author: '',
  };

  constructor(
    private datePipe: DatePipe,
    private resourceService: LearningResourceService,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    const id = this.activatedRoute.snapshot.paramMap.get('id');
    if (id) {
      this.resourceService.getSingleArticle(id).then((resp) => {
        this.article = resp;
        this.initCrumbs();
      });
    }
  }

  initCrumbs(): void {
    this.breadcrumbs = [
      {
        title: 'Learning Resource-Articles ',
        route: '/admin/resources-article',
      },
      {
        title: this.article.name,
      },
    ];
  }

  formatDate(startDate: string): any {
    const start = new Date(startDate);

    if (isNaN(start.getTime())) {
      return 'Invalid Date Range';
    }

    const startYear = start.getFullYear();
    const startMonth = new Intl.DateTimeFormat('en-US', {
      month: 'long',
    }).format(start);
    const startDay = start.getDate();

    const startDateStr = `${startMonth} ${startDay} ${startYear}`;

    return `${startDateStr}`;
  }
  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/placeholder_image.jpg';
  }

  serializeToHTML(children: any[]): string {
    return children
      .map((node, i) => {
        if (node && typeof node === 'object' && 'text' in node) {
          let text = `<span>${this.escapeHTML(node.text)}</span>`;

          if (node.bold) {
            text = `<strong>${text}</strong>`;
          }

          if (node.code) {
            text = `<code>${text}</code>`;
          }

          if (node.italic) {
            text = `<em>${text}</em>`;
          }

          if (node.underline) {
            text = `<u>${text}</u>`;
          }

          return text;
        }

        if (!node) {
          return null;
        }

        switch (node.type) {
          case 'h1':
            return `<h1>${this.serializeToHTML(node.children)}</h1>`;
          case 'h2':
            return `<h2>${this.serializeToHTML(node.children)}</h2>`;
          case 'h3':
            return `<h3>${this.serializeToHTML(node.children)}</h3>`;
          case 'h4':
            return `<h4>${this.serializeToHTML(node.children)}</h4>`;
          case 'h5':
            return `<h5>${this.serializeToHTML(node.children)}</h5>`;
          case 'h6':
            return `<h6>${this.serializeToHTML(node.children)}</h6>`;
          case 'blockquote':
            return `<blockquote>${this.serializeToHTML(node.children)}</blockquote>`;
          case 'ul':
            return `<ul>${this.serializeToHTML(node.children)}</ul>`;
          case 'ol':
            return `<ol>${this.serializeToHTML(node.children)}</ol>`;
          case 'li':
            return `<li>${this.serializeToHTML(node.children)}</li>`;
          case 'link':
            return `<a class="richLink" href="${this.escapeHTML(node.url)}">${this.serializeToHTML(
              node.children
            )}</a>`;

          default:
            return `<p class="font-[400]">${this.serializeToHTML(node.children)}</p>`;
        }
      })
      .join('');
  }

  private escapeHTML(text: string): string {
    return text;
  }
}
